import fetch from '@giro/shared-utils/fetch.util';

export default async function postDispatchService(payload) {
  return fetch(`dispatch`, {
    method: 'POST',
    ms: 'LINK',
    auth: true,
    body: JSON.stringify(payload),
  });
}
